import * as moment from "moment-timezone";

export interface ScheduledContent<T> {
  id: string;
  dateUtc: moment.Moment;
  content: T;
  type: ScheduledType;
}

export enum ScheduledType {
  InsightMessage = "InsightMessage",
  GlobalAlertMessage = "GlobalAlertMessage"
}



// WEBPACK FOOTER //
// ./src/app/shared/models/ScheduledContent.ts